import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import {
    fetchTaxiServiceType,
    createTaxiServiceType,
    updateTaxiServiceType,
    deleteTaxiServiceType,
} from '../../api/administration/taxiServiceTypeApi';

export const useTaxiServicesTypes = () => {
    const queryClient = useQueryClient();

    const { data: taxiServicesTypes = [], isLoading, error } = useQuery({
        queryKey: ['taxi-tipos-servicios'],
        queryFn: fetchTaxiServiceType,
    });

    const createMutation = useMutation({
        mutationFn: createTaxiServiceType,
        onSuccess: () => {
            queryClient.invalidateQueries({ queryKey: ['taxi-tipos-servicios'] });
        },
    });

    const updateMutation = useMutation({
        mutationFn: ({ id, data }) => updateTaxiServiceType(id, data),
        onSuccess: () => {
            queryClient.invalidateQueries({ queryKey: ['taxi-tipos-servicios'] });
        },
    });

    const deleteMutation = useMutation({
        mutationFn: deleteTaxiServiceType,
        onSuccess: () => {
            queryClient.invalidateQueries({ queryKey: ['taxi-tipos-servicios'] });
        },
    });

    return {
        taxiServicesTypes,
        isLoading,
        error,
        createMutation,
        updateMutation,
        deleteMutation,
    };
};
